import React from "react";

const TimerIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C10.7933 13.5 13.1002 11.4177 13.4532 8.72073L12.8201 9.35361C12.6248 9.54884 12.3083 9.54879 12.113 9.3535C11.9178 9.15821 11.9178 8.84163 12.1131 8.64639L13.4469 7.31306C13.5406 7.21931 13.6678 7.16665 13.8004 7.16667C13.933 7.16669 14.0602 7.21938 14.154 7.31317L15.4869 8.6465C15.6821 8.84179 15.6821 9.15837 15.4868 9.35361C15.2915 9.54884 14.9749 9.54879 14.7797 9.3535L14.4239 8.99762C13.9439 12.1139 11.2506 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C10.3853 1.5 12.47 2.78515 13.6002 4.69842C13.7406 4.93618 13.6617 5.24278 13.424 5.38323C13.1862 5.52367 12.8796 5.44479 12.7392 5.20703C11.7814 3.5857 10.0172 2.5 8 2.5ZM8 4.16667C8.27614 4.16667 8.5 4.39052 8.5 4.66667V7.73241L10.2774 8.91731C10.5071 9.07048 10.5692 9.38092 10.416 9.61068C10.2628 9.84045 9.95242 9.90254 9.72265 9.74936L7.72265 8.41603C7.58355 8.32329 7.5 8.16718 7.5 8V4.66667C7.5 4.39052 7.72386 4.16667 8 4.16667Z"
        fill="#17142A"
      />
    </svg>
  );
};

export default TimerIcon;
